import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './ElementItem.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({ref:"element",tag:"component",staticClass:"b24-element-item",class:_vm.classList,on:{"click":_vm.handlerClickItem}},'component',_vm.bindAttrs,false),[(_vm.$slots.prepend)?_c('div',{staticClass:"b24-element-item__slot _after"},[_vm._t("prepend")],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"b24-element-item__text"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.append)?_c('div',{staticClass:"b24-element-item__slot _before"},[_vm._t("append")],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
